

























import { Component, Vue } from 'vue-property-decorator'
import router from '../router'

@Component
export default class ForgetPassword extends Vue {
  form = {
    email: '',
  }

  loading: boolean = false

  rules = {
    email: [
      { required: true, message: 'Email must not be empty', trigger: 'blur' },
    ]
  }

  async reset() {
    if (!this.form.email) {
      return this.$message.error('Email must not be empty');
    }
    this.loading = true
    this.$store.dispatch('forgetPassword', this.form.email).then(() => {
      this.loading = false
      this.$success({
        title: `Email has been sent to ${this.form.email}`,
        content: 'You will receive an email to reset password if you have account with us',
        okText: 'Back to login',
        onOk() {
          router.push({name: 'Login'})
        }
      })
    })
  }
}
